import { get } from '../client';

export const dashboardApi = {
  getCounts: () => get('/dashboard'),
  villageSummary: () => get('/dashboard/village-summary'),
  buSiteSummary: (params = {}) => get('/dashboard/bu-site-summary', { params }),
};
